import React, { Component } from "react";
import {
  UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from "reactstrap";

class ActionsDropdown extends Component {

  render() {
    const { title="Actions", actions=[] } = this.props;

    return (
			<UncontrolledDropdown
				className="me-2"
				direction="down"
			>
				<DropdownToggle
					caret
					color="primary"
				>
					{title}
				</DropdownToggle>
				<DropdownMenu>
					{
						actions.map((action, index) => {
							return (
								<DropdownItem className="px-2" key={index} disabled={action.disabled} onClick={action.onClick}>
									{action.title}
								</DropdownItem>
							)
						})
					}
				</DropdownMenu>
			</UncontrolledDropdown>
    );
  }
}

export default ActionsDropdown;
